'use client';

import type { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export {
  faChevronRight,
  faChevronUp,
  faChevronLeft,
  faChevronDown,
  faXmark,
  faGlobe,
  faArrowUpFromBracket,
  faArrowUpRightFromSquare,
  faCopy,
  faCirclePlus,
  faLink,
  faSliders,
  faPalette,
  faCheck,
  faAnglesRight,
} from '@fortawesome/free-solid-svg-icons';

export {
  faXTwitter,
  faInstagram,
  faYoutube,
  faTiktok,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons';

type Props = {
  icon: IconDefinition;
  size?: SizeProp;
};

function FaIcon({ icon, size }: Props) {
  return <FontAwesomeIcon icon={icon} size={size} />;
}

export default FaIcon;
